
import { useState } from 'react';

export default function TestimonialsSection() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      name: '田中 美咲',
      location: '京都市在住',
      rating: 4.9,
      comment: '木の香りと珈琲の香りが混ざり合う空間で、時間を忘れてしまいます。自家焙煎の珈琲は本当に香り高く、毎回感動します。町家の趣ある雰囲気の中で過ごす時間は、日常の疲れを癒してくれる特別なひとときです。',
      avatar: 'https://public.readdy.ai/ai/img_res/60581561b280c2dd623d8015d16b237c.jpg'
    },
    {
      name: '佐藤 健一',
      location: '大阪府在住',
      rating: 5.0,
      comment: '出張で京都を訪れた際に偶然見つけたこちらのお店。落ち着いた照明と木の温もりに包まれて、仕事の疲れが一気に癒されました。季節の和菓子も絶品で、また必ず訪れたいと思います。',
      avatar: 'https://readdy.ai/api/search-image?query=Japanese%20businessman%20in%20his%2040s%20smiling%2C%20professional%20portrait%2C%20natural%20lighting%2C%20friendly%20demeanor%2C%20business%20casual%20attire&width=100&height=100&seq=customer2&orientation=squarish'
    },
    {
      name: '山田 花子',
      location: '奈良県在住',
      rating: 4.8,
      comment: '友人との待ち合わせでよく利用させていただいています。静かで居心地が良く、会話も弾みます。スタッフの方々のおもてなしも素晴らしく、いつも温かい気持ちになります。',
      avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20her%2020s%20with%20bright%20smile%2C%20casual%20portrait%2C%20natural%20expression%2C%20warm%20personality%2C%20friendly%20appearance&width=100&height=100&seq=customer3&orientation=squarish'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentTestimonial];

  return (
    <section id="testimonials" className="py-20 bg-stone-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-900 mb-6" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            「お客様の声」
          </h2>
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 relative">
          {/* 評価ラベル */}
          <div className="absolute top-6 left-6">
            <div className="bg-amber-900 text-white px-4 py-2 rounded-full flex items-center space-x-2">
              <i className="ri-star-fill text-yellow-400"></i>
              <span className="font-semibold">{current.rating}</span>
            </div>
          </div>

          {/* レビュー本文 */}
          <div className="text-center mb-8">
            <blockquote className="text-xl md:text-2xl text-gray-800 leading-relaxed italic mb-8 mt-8" style={{ fontFamily: 'Noto Serif JP, serif' }}>
              「{current.comment}」
            </blockquote>

            {/* ユーザー情報 */}
            <div className="flex items-center justify-center space-x-4">
              <img
                src={current.avatar}
                alt={current.name}
                className="w-16 h-16 rounded-full object-cover"
              />
              <div className="text-left">
                <div className="font-semibold text-lg text-gray-900">{current.name}</div>
                <div className="text-gray-600">{current.location}</div>
              </div>
            </div>
          </div>

          {/* ナビゲーションボタン */}
          <div className="absolute bottom-6 right-6 flex space-x-2">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 bg-white border-2 border-amber-800 text-amber-800 rounded-full flex items-center justify-center hover:bg-amber-800 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={nextTestimonial}
              className="w-12 h-12 bg-amber-800 text-white rounded-full flex items-center justify-center hover:bg-amber-900 transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          {/* インジケーター */}
          <div className="flex justify-center space-x-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-colors duration-300 cursor-pointer ${
                  index === currentTestimonial ? 'bg-amber-800' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
